// extracted by mini-css-extract-plugin
export default {"prev-button":"PrevArrow_prev-button__qRKz-"};